import i18n from '@/app-shared/i18n';

export default {
  menus: [
    {
      key: 'lottery',
      name: i18n.t('interact_tools.interact_tools_1003'),
      authKey: 'ui.hide_lottery',
      iconCls: 'vh-iconfont vh-a-line-luckydraw'
    },
    {
      key: 'exam',
      name: i18n.t('exam.exam_1047'),
      authKey: 'exam',
      iconCls: 'vh-iconfont vh-a-line-Sentaanswer'
    },
    {
      key: 'sign',
      name: i18n.t('interact_tools.interact_tools_1024'),
      authKey: 'ui.hide_sign_in',
      iconCls: 'vh-iconfont vh-line-order'
    },
    {
      key: 'mallreward',
      name: i18n.t('interact_tools.interact_tools_1156'),
      authKey: 'mall_reward',
      iconCls: 'vh-iconfont vh-a-line-mallreward'
    },
    {
      key: 'questionnaire',
      name: i18n.t('form.form_1074'),
      authKey: 'ui.hide_survey',
      iconCls: 'vh-iconfont vh-line-questionnaire'
    },
    {
      key: 'qa',
      name: i18n.t('common.common_1004'),
      authKey: 'ui.is_hide_qa_button',
      iconCls: 'vh-iconfont vh-a-line-qanda',
      useInLiving: true
    },
    {
      key: 'redpacket',
      name: i18n.t('interact_tools.interact_tools_1098'),
      authKey: 'ui.show_redpacket',
      iconCls: 'vh-iconfont vh-a-line-redpacket',
      useInLiving: true
    },
    {
      key: 'timer',
      name: i18n.t('interact_tools.interact_tools_1099'),
      authKey: 'webinar.timer',
      iconCls: 'vh-iconfont vh-line-time',
      useInLiving: true
    },
    {
      key: 'pushcard',
      name: i18n.t('interact_tools.interact_tools_1122'),
      authKey: 'push_screen_card',
      iconCls: 'vh-iconfont vh-line-card'
    },
    {
      key: 'rebroadcast',
      name: i18n.t('interact_tools.interact_tools_1153'),
      authKey: 'rebroadcast',
      iconCls: 'vh-saas-iconfont vh-saas-a-color-Playbackmanagement'
    },
    {
      key: 'watchgift',
      name: i18n.t('interact_tools.interact_tools_1151'),
      authKey: 'watch_gift',
      iconCls: 'vh-iconfont vh-guankanyouli'
    },
    {
      key: 'cashredpacket',
      name: i18n.t('interact_tools.interact_tools_1155'),
      authKey: 'cash_red_packet',
      iconCls: 'vh-iconfont vh-a-line-redpacket'
    },
    {
      key: 'inactive_kick',
      name: i18n.t('interact.interact_1049'),
      authKey: 'inactive_kick',
      iconCls: 'vh-saas-iconfont vh-saas-line-blacklist'
    }
  ]
};
